import en from './auth.en.json';
import fr from './auth.fr.json';

const AuthTranslations = {
  en,
  fr,
};

export { AuthTranslations };
